// @core/api/endpoints/calendar/get_calendar_event_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarEventTypeDefinitionResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get calendar event type
 * Returns a calendar event type definition by ID or slug.
 */
export async function GetCalendarEventType(
  type_id: string,
  options?: RequestOptions
): Promise<CalendarEventTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar-event-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.get<CalendarEventTypeDefinitionResponse>(requestPath, { ...requestOptions });
}
